
  import { Component, Vue } from 'vue-property-decorator';
  import { mapGetters } from 'vuex';

  import twitchService from '@/services/twitch.service';

  @Component({
    computed: {
      ...mapGetters([
        'token'
      ])
    }
  })
  export default class TwitchUnlink extends Vue {
    created() {
      this.$store.watch(() => this.$store.getters.token, token => {
        twitchService.unlinkTwitch(this, token);
      })

      if (this.$store.getters.token != null) {
        twitchService.unlinkTwitch(this, this.$store.getters.token);
      }
    }
  }
